<template>
	<div class="container-fluid p-0">
		<Header />
		<router-view></router-view>
	</div>
</template>

<script>
import Header from '@/components/onboarding/layout/Header.vue'
import { mapGetters, mapState } from 'vuex'
export default {
	name: 'Dashboard',
	components: { Header },
	computed: {
		...mapState(['authUser', 'dashboardDark']),
		...mapGetters(['isAuth']),
	},
	mounted: function() {
		this.syncDashboardTheme(this.dashboardDark)
	},
	beforeDestroy() {
		document.body.classList.remove('dashboard-dark')
	},
	watch: {
		dashboardDark(newValue) {
			this.syncDashboardTheme(newValue)
		},
	},
	created() {
		//this.auth()
	},
	methods: {
		syncDashboardTheme(isDark) {
			document.body.classList.toggle('dashboard-dark', isDark)
		},
	},
}
</script>
